// extracted by mini-css-extract-plugin
export default {"TeamVsTeamContainer":"TeamVsTeamSection_TeamVsTeamContainer__SJBaT"};